(function () {
  function getPickerAndEmptyGroups(root) {
    var picker = root.querySelector('variant-selects');
    if (!picker) return null;

    var pillGroups = picker.querySelectorAll('.product-form__input--pills');
    var emptyGroups = Array.prototype.filter.call(pillGroups, function (group) {
      return !group.querySelector('input[type="radio"]:checked');
    });

    return { picker: picker, emptyGroups: emptyGroups };
  }

  function showError(form, emptyGroups) {
    var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    var errorText = form.querySelector('.product-form__error-message');
    if (errorWrapper && errorText) {
      errorText.textContent = 'Kerjuk, valassz meretet a kosarba helyezes elott.';
      errorWrapper.hidden = false;
    }

    emptyGroups.forEach(function (group) {
      group.classList.add('variant-picker-error');
      group.classList.remove('shake-error');
      void group.offsetWidth;
      group.classList.add('shake-error');

      var msg = group.nextElementSibling;
      if (!msg || !msg.classList.contains('variant-picker-error-msg')) {
        msg = document.createElement('p');
        msg.className = 'variant-picker-error-msg';
        msg.textContent = 'Válassz méretet és színt kosárba helyezés előtt!';
        group.insertAdjacentElement('afterend', msg);
      } else {
        msg.hidden = false;
      }

      group.addEventListener('change', function onChange() {
        group.classList.remove('variant-picker-error', 'shake-error');
        var existingMsg = group.nextElementSibling;
        if (existingMsg && existingMsg.classList.contains('variant-picker-error-msg')) {
          existingMsg.remove();
        }
        group.removeEventListener('change', onChange);
      });
    });

    emptyGroups[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // 1) Sima "Kosárba" gomb - natív submit esemény
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-type="add-to-cart-form"]')) return;

    var section = form.closest('.shopify-section');
    if (!section) return;

    var result = getPickerAndEmptyGroups(section);
    if (!result || result.emptyGroups.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    showError(form, result.emptyGroups);
  }, true);

  // 2) Releasit "Utánvétes Rendelés" gomb - saját kattintás-kezelő, nem submit
  document.addEventListener('click', function (e) {
    var rsiButton = e.target.closest('#_rsi-buy-now-button, ._rsi-buy-now-button');
    if (!rsiButton) return;

    var section = rsiButton.closest('.shopify-section');
    if (!section) return;

    var result = getPickerAndEmptyGroups(section);
    if (!result || result.emptyGroups.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = section.querySelector('[data-type="add-to-cart-form"]');
    if (form) showError(form, result.emptyGroups);
  }, true);
})();